import React, { useEffect, useState } from "react";
import api from "../services/api";

function AddStudent({ setPage }) {

const [firstName,setFirstName] = useState("");
const [lastName,setLastName] = useState("");
const [email,setEmail] = useState("");
const [mobile,setMobile] = useState("");
const [password,setPassword] = useState("");
const [batches,setBatches] = useState([""]);
const [status,setStatus] = useState("active");

// Product access is centrally managed by MaAz Admin.
// Existing LMS behavior stays enabled by default; Live is opt-in.
const [productAccess,setProductAccess] = useState({
  lms:true,
  live:false
});

const [showPassword,setShowPassword] = useState(false);

const [courses,setCourses] = useState([]);
const [modules,setModules] = useState([]);

const [courseAccess,setCourseAccess] = useState([
{
course_id:"",
access_type:"full",
module_ids:[],
video_source:"maaz",
start_date:"",
end_date:"",
status:"active"
}
]);

useEffect(()=>{
loadCourses();
loadModules();
},[]);

const updateBatch = (index,value)=>{
const updated=[...batches];
updated[index]=value;
setBatches(updated);
};

const addBatch = ()=>{
setBatches([...batches,""]);
};

const removeBatch = (index)=>{
const updated=batches.filter((_,i)=>i!==index);
setBatches(updated);
};

const loadCourses = async ()=>{
try{
const res = await api.get("/courses");
setCourses(res.data.data || []);
}catch(err){
console.log("Courses load error",err);
}
};

const loadModules = async ()=>{
try{
const res = await api.get("/modules");
setModules(res.data.data || []);
}catch(err){
console.log("Modules load error",err);
}
};

const addCourseAccess = ()=>{
setCourseAccess([
...courseAccess,
{
course_id:"",
access_type:"full",
module_ids:[],
video_source:"maaz",
start_date:"",
end_date:"",
status:"active"
}
]);
};

const updateCourseAccess=(index,field,value)=>{
const updated=[...courseAccess];
updated[index][field]=value;

if(field==="course_id"){
updated[index].module_ids=[];
}

setCourseAccess(updated);
};

const toggleModule=(accessIndex,moduleId)=>{

const updated=[...courseAccess];
const selected=updated[accessIndex].module_ids || [];

if(selected.includes(moduleId)){
updated[accessIndex].module_ids =
selected.filter(id=>id!==moduleId);
}else{
updated[accessIndex].module_ids =
[...selected,moduleId];
}

setCourseAccess(updated);
};

const getModulesForCourse=(courseId)=>{
return modules.filter(m=>String(m.course_id)===String(courseId));
};

const saveStudent = async ()=>{

if(!firstName || !email || !password){
alert("First Name, Email and Password are required");
return;
}

// ✅ NEW VALIDATION
if(!batches.length || !batches.some(b => b.trim() !== "")){
  alert("Batch is required");
  return;
}

try{

// ✅ FIX: sanitize video_source ONLY (no other changes)
const cleanedCourses = courseAccess.map(c => ({
  ...c,
  video_source:
    (c.video_source || "").toLowerCase().includes("bunny")
      ? "bunny"
      : "maaz"
}));

await api.post("/students",{
first_name:firstName.trim(),
last_name:lastName.trim(),
email: email.toLowerCase().trim(),
mobile,
password,
status,
batches:batches.filter(b=>b.trim() !== ""),
product_access:{
  lms:Boolean(productAccess.lms),
  live:Boolean(productAccess.live)
},
courses: cleanedCourses
});

alert("Student Created Successfully");

setPage({page: "students"});

}catch(err){

  console.log("Create student error:",err.response?.data || err);

  const msg =
    err?.response?.data?.message || "Failed to create student";

  alert(msg);

}
};

return(

<div style={{padding:"30px",maxWidth:"1000px"}}>

<h2 style={{marginBottom:"25px"}}>Add Student</h2>

<div style={card}>

<input
placeholder="First Name"
value={firstName}
onChange={(e)=>setFirstName(e.target.value)}
style={input}
/>

<input
placeholder="Last Name (Optional)"
value={lastName}
onChange={(e)=>setLastName(e.target.value)}
style={input}
/>

<input
placeholder="Email"
autoComplete="off"
value={email}
onChange={(e)=>setEmail(e.target.value)}
style={input}
/>

<input
placeholder="Mobile"
autoComplete="off"
value={mobile}
onChange={(e)=>setMobile(e.target.value)}
style={input}
/>

<select
value={status}
onChange={(e)=>setStatus(e.target.value)}
style={input}
>
<option value="active">Active</option>
<option value="inactive">Inactive</option>
</select>

<div style={{position:"relative",marginBottom:"15px"}}>

<input
placeholder="Password"
type={showPassword ? "text" : "password"}
autoComplete="new-password"
value={password}
onChange={(e)=>setPassword(e.target.value)}
style={input}
/>

<button
type="button"
onClick={()=>setShowPassword(!showPassword)}
style={showBtn}
>
{showPassword ? "Hide" : "Show"}
</button>

</div>

</div>

<div style={card}>

<h3 style={{marginTop:0,marginBottom:"8px"}}>Product Access</h3>
<p style={{marginTop:0,color:"#667085",fontSize:"13px",marginBottom:"18px"}}>
Choose which MaAz products this student can access with the same login credentials.
</p>

<div style={productAccessGrid}>

<label style={{...productAccessOption,...(productAccess.lms ? productAccessOptionActive : {})}}>
<input
  type="checkbox"
  checked={productAccess.lms}
  onChange={(e)=>setProductAccess(prev=>({...prev,lms:e.target.checked}))}
  style={productCheckbox}
/>
<div>
  <strong style={{display:"block",marginBottom:"4px"}}>MaAz LMS</strong>
  <span style={productDescription}>Courses, modules, lessons and recordings</span>
</div>
<span style={productStatus(productAccess.lms)}>{productAccess.lms ? "Enabled" : "Disabled"}</span>
</label>

<label style={{...productAccessOption,...(productAccess.live ? productAccessOptionActive : {})}}>
<input
  type="checkbox"
  checked={productAccess.live}
  onChange={(e)=>setProductAccess(prev=>({...prev,live:e.target.checked}))}
  style={productCheckbox}
/>
<div>
  <strong style={{display:"block",marginBottom:"4px"}}>MaAz Live</strong>
  <span style={productDescription}>Join scheduled MaAz Live classroom sessions</span>
</div>
<span style={productStatus(productAccess.live)}>{productAccess.live ? "Enabled" : "Disabled"}</span>
</label>

</div>

</div>

<div style={card}>

<h3>Batch Numbers</h3>

{batches.map((batch,index)=>(

<div key={index} style={{display:"flex",marginBottom:"10px"}}>

<input
placeholder="Batch Number (ex: PFA9, AET31)"
value={batch}
onChange={(e)=>updateBatch(index,e.target.value)}
style={{...input,flex:1,marginBottom:"0"}}
/>

{index !== 0 && (

<button
type="button"
onClick={()=>removeBatch(index)}
style={dangerBtn}
>
Remove
</button>

)}

</div>

))}

<button type="button" onClick={addBatch} style={blueBtn}>
+ Add Batch
</button>

</div>

<div style={card}>

<h3>Course Access</h3>

{courseAccess.map((access,index)=>(

<div key={index} style={courseCard}>

<select
value={access.course_id}
onChange={(e)=>updateCourseAccess(index,"course_id",e.target.value)}
style={input}
>
<option value="">Select Course</option>
{courses.map(c=>(
<option key={c.id} value={c.id}>
{c.title}
</option>
))}
</select>

<select
value={access.access_type}
onChange={(e)=>updateCourseAccess(index,"access_type",e.target.value)}
style={input}
>
<option value="full">Complete Access</option>
<option value="partial">Partial Access</option>
</select>

<select
value={access.video_source}
onChange={(e)=>updateCourseAccess(index,"video_source",e.target.value)}
style={input}
>
<option value="maaz">MaAz Secure Stream</option>
<option value="bunny">Bunny CDN Secure Stream</option>
</select>

<select
value={access.status}
onChange={(e)=>updateCourseAccess(index,"status",e.target.value)}
style={input}
>
<option value="active">Active</option>
<option value="inactive">Inactive</option>
</select>

{access.access_type==="partial" && access.course_id && (

<div style={{marginBottom:"10px"}}>

<strong>Select Modules</strong>

{getModulesForCourse(access.course_id).map(module=>(

<div key={module.id}>

<label>

<input
type="checkbox"
checked={(access.module_ids || []).includes(module.id)}
onChange={()=>toggleModule(index,module.id)}
/>

{" "}{module.title}

</label>

</div>

))}

</div>

)}

<label>Start Date</label>

<input
type="date"
value={access.start_date}
onChange={(e)=>updateCourseAccess(index,"start_date",e.target.value)}
style={input}
/>

<label>End Date</label>

<input
type="date"
value={access.end_date}
onChange={(e)=>updateCourseAccess(index,"end_date",e.target.value)}
style={input}
/>

</div>

))}

<button onClick={addCourseAccess} style={blueBtn}>
+ Add Course Access
</button>

</div>

<div style={{marginTop:"20px"}}>

<button style={primaryBtn} onClick={saveStudent}>
Save Student
</button>

<button
style={{...secondaryBtn,marginLeft:"10px"}}
onClick={()=>setPage("students")}
>
Cancel
</button>

</div>

</div>

)

}

const card={
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"25px"
};

const courseCard={
border:"1px solid #eee",
padding:"15px",
marginBottom:"15px",
borderRadius:"6px",
background:"#fafafa"
};

const input={
width:"100%",
padding:"10px",
marginBottom:"15px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"
};

const primaryBtn={
background:"#2c3e50",
color:"#fff",
border:"none",
padding:"10px 18px",
borderRadius:"6px",
cursor:"pointer"
};

const secondaryBtn={
padding:"10px 18px",
borderRadius:"6px",
border:"1px solid #ccc",
cursor:"pointer",
background:"#fff"
};

const blueBtn={
background:"#3498db",
color:"white",
border:"none",
padding:"8px 14px",
borderRadius:"6px",
cursor:"pointer",
marginTop:"10px"
};

const dangerBtn={
marginLeft:"10px",
background:"#e74c3c",
color:"white",
border:"none",
padding:"8px 12px",
borderRadius:"6px",
cursor:"pointer"
};

const showBtn={
position:"absolute",
right:"10px",
top:"8px",
border:"none",
background:"none",
cursor:"pointer",
fontSize:"12px"
};

const productAccessGrid={
display:"grid",
gridTemplateColumns:"repeat(2,minmax(0,1fr))",
gap:"14px"
};

const productAccessOption={
display:"grid",
gridTemplateColumns:"auto 1fr auto",
alignItems:"center",
gap:"12px",
padding:"16px",
border:"1px solid #e5e7eb",
borderRadius:"10px",
background:"#fafafa",
cursor:"pointer"
};

const productAccessOptionActive={
border:"1px solid #d71920",
background:"#fff7f7"
};

const productCheckbox={
width:"18px",
height:"18px",
accentColor:"#d71920"
};

const productDescription={
fontSize:"12px",
color:"#667085",
lineHeight:"1.45"
};

const productStatus=(enabled)=>({
fontSize:"11px",
fontWeight:"700",
padding:"5px 8px",
borderRadius:"999px",
color:enabled ? "#16794b" : "#667085",
background:enabled ? "#eaf8f1" : "#eef0f2"
});

export default AddStudent;
